import { useEffect, useState } from "react";
import { formatTinNo } from "./utils";
import soleProprietorDetails from "./schema/soleProprietorDetails.json";
import FormFactory from "../../../../../components/FormFactory";
import { set } from "nq-js/dist/Config";
import FormField from "./FormField";
import InputFactory from "../../../../../components/InputFactory";
import clientSchema from "./schema/clientSchema.json";

function BasicInfoFields({
  object,
  formData,
  onChange,
  businessType,
  ...props
}) {
  return (
    <>
      <div className="mt-2">
        <FormFactory
          object={formData}
          schema={clientSchema}
          onChange={onChange}
          className="d-flex"
          {...props}
        />
        <FormField
          label="Tax Identification Number"
          required
          className={"mt-1 col-12 col-lg-6 fw-bold"}
        >
          <InputFactory
            type="String"
            field="tinNo"
            required
            object={formData}
            onChange={onChange}
            placeholder="e.g. 123-456-789-00000"
            minLength={11}
          />
        </FormField>
      </div>
    </>
  );
}

export default BasicInfoFields;
